import { render, staticRenderFns } from "./entityLabels.vue?vue&type=template&id=7b654304"
import script from "./entityLabels.vue?vue&type=script&lang=js"
export * from "./entityLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports